<script lang="ts" setup>
import { ChecklistCriteria, CriteriaInstance } from "types/Checklist";

const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});

defineEmits(["reportProblem"]);

const documentId = inject("documentId") as any;
const store = useStepResultsStore(documentId);
const { evaluationResults, error, isLoadingResults, didFailEvaluation } =
  storeToRefs(store);
</script>

<template>
  <div class="flex flex-col">
    <BaseLoading class="grow min-h-0" v-if="isLoadingResults" />
    <div v-if="error">There's some error getting the evaluation results.</div>
    <EvaluationResultsTree
      v-if="
        evaluationResults != undefined &&
        isLoadingResults != true &&
        didFailEvaluation != true
      "
      class="grow min-h-0 overflow-auto"
      :criteria-instance="criteriaInstance"
      :checklist-criteria="checklistCriteria"
      :evaluation-results="evaluationResults"
      @reportProblem="$emit('reportProblem', $event)"
    />
  </div>
</template>

<style scoped></style>
